import { render, staticRenderFns } from "./BinNumberPage.vue?vue&type=template&id=f2890368&"
import script from "./BinNumberPage.vue?vue&type=script&lang=js&"
export * from "./BinNumberPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports